import e from "@dialpad/dialtone-tokens/layered/themes/tokens-102-colors.css?inline";
//#region themes/102.js
var t = { brand: {
	css: e,
	name: "102"
} };
//#endregion
export { t as default };
